module.exports = __webpack_public_path__ + "fonts/d154040021ee788509c7012bccecdfcc.svg";